import { EnumQuestionType } from "@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master"

export const getQuestionTypeDisplayValue = (
  questionType: number,
  translateFunc: (key: string) => string
) => {
  const value = EnumQuestionType[questionType];
  return translateFunc(`EnumQuestionType.${value}`)
}
